import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SignatureService {
  private _visible = new BehaviorSubject<boolean>(false);
  visible$ = this._visible.asObservable();
  private _resolve: ((dataUrl: string) => void) | null = null;

  open(): Promise<string> {
    this._visible.next(true);
    return new Promise((resolve) => {
      this._resolve = resolve;
    });
  }

  submit(dataUrl: string) {
    this._visible.next(false);
    this._resolve?.(dataUrl);
    this._resolve = null;
  }

  cancel() {
    this._visible.next(false);
    this._resolve = null;
  }
}
